import React from "react";

const Button = ({
  btnText,
  btnBgColor,
  btnColor,
  btnRadius,
  btnPadding,
  hoverColor,
  handleClick,
  btnBorderColor,
  btnWidth,
  btnHeight,
  fontWeight,
}) => {
  return (
    <button
      className="f  cursor-pointer "
      style={{
        backgroundColor: btnBgColor,
        color: btnColor,
        borderRadius: btnRadius,
        padding: btnPadding,
        hover: hoverColor,
        borderColor: btnBorderColor,
        borderWidth: btnBorderColor ? "1px" : "0px",
        borderStyle: btnBorderColor ? "solid" : "none",
        width: btnWidth,
        height: btnHeight,
        fontWeight: fontWeight,
        fontWeight: fontWeight,
      }}
      onClick={handleClick}
    >
      {btnText}
    </button>
  );
};

export default Button;
